export const prospectData = ({ prospect }) => prospect;
